import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/patreon': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3 101.4 0 183.8 82.7 183.8 184.3zM0 501.5v-491h90v491h-90z'
      }
    ]
  }
})
